import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=40970a94&scoped=true&"
import script from "./LoginButton.vue?vue&type=script&lang=js&"
export * from "./LoginButton.vue?vue&type=script&lang=js&"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=40970a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40970a94",
  null
  
)

export default component.exports